/* Ajout au panier depuis une carte produit (snippets/mm-fc-card, blocs et sections qui la rendent).
   Source unique : appele par les attributs onclick des cartes, disponible sur toutes les pages. */
/* Roue de secours commune (29/09/2026) : quand une étape de l'ajout au panier échoue, on relit
   le panier et on ouvre le tiroir au lieu d'envoyer sur la page /cart (Khalid a été renvoyé sur /cart
   après un ajout). La page /cart ne sert plus qu'en tout dernier recours : pas de tiroir sur la page. */
window.MMPanierSecours = function (erreur) {
  if (erreur) console.error('[MM panier]', erreur);
  var tiroir = document.querySelector('cart-drawer');
  try {
    if (tiroir && typeof tiroir.refresh === 'function') { tiroir.refresh({ open: true }); return; }
    if (tiroir && typeof tiroir.open === 'function') { tiroir.open(); return; }
  } catch (e) { console.error('[MM panier]', e); }
  window.location.href = '/cart';
};

window.MMCardAddToDrawer = function (btn) {
  if (btn.disabled) return;
  var variantId = btn.dataset.variant;
  if (!variantId) return;
  // Le bouton est désactivé pendant l'ajout et perd le focus : le tiroir le retient pour le
  // lui rendre à la fermeture (sinon le focus retombait en haut de page, audit du 27/09/2026).
  var tiroir = document.querySelector('cart-drawer');
  if (tiroir && typeof tiroir.setActiveElement === 'function' && !tiroir.contains(btn)) tiroir.setActiveElement(btn);
  btn.disabled = true;
  btn.classList.add('is-loading');
  fetch(`${routes.cart_add_url}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({
      id: parseInt(variantId, 10),
      quantity: 1,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    })
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var drawer = document.querySelector('cart-drawer');
      /* Refus de Shopify (stock insuffisant…) : la réponse porte un status sans sections.
         Avant, l'échec était muet pour la cliente (audit 27/09/2026). */
      if (data && data.status && !data.sections) {
        if (drawer && typeof drawer.showError === 'function') {
          if (typeof drawer.open === 'function') drawer.open();
          drawer.showError(new Error(data.description || data.message || (window.cartStrings && window.cartStrings.error) || ''));
        }
        return;
      }
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
      } else {
        (window.MMPanierSecours || function () { window.location.href = '/cart'; })();
      }
    })
    .catch(function (e) { (window.MMPanierSecours || function () { window.location.href = '/cart'; })(e); })
    .finally(function () {
      btn.disabled = false;
      btn.classList.remove('is-loading');
    });
};
